import { createAction } from '../../utils/reduxUtils';
import { AsyncError } from '../../common';
import { LandingPageType, LoadSuccess } from './models';

const loadTours = {
  request: createAction('@landing/LOAD_TOURS_REQUEST')<LandingPageType>,
  success: createAction('@landing/LOAD_TOURS_SUCCESS')<LoadSuccess>,
  failure: createAction('@landing/LOAD_TOURS_FAILURE')<AsyncError>,
};


const actions = {
  loadTours,
};

export default actions;